import React, { useContext } from 'react';
import ProductGrid from '@core-ui/product-grid';
import catPriceAdapter from '@core-ui/price-case/adapters/category-price';
import { FeatureFlagsContext } from '@core-ui/feature-flags';
import ProductGridError from '../product-grid-error';
import { PageDataContext } from '../../providers/page-data-provider';
import { useClpState } from '../../providers/app-state-provider';
import { CLPProductCard } from '../product-card';
import { ComposableProductGrid } from '../composable-product-grid';

export const CustomLandingPageProductGrid = (): JSX.Element => {
  const { brand, locale, showComposableProductCard } = useClpState();
  const { productGroups } = useContext(PageDataContext);
  const { enabledFeatures } = useContext(FeatureFlagsContext);
  const totalItemCount = productGroups[0].products.length;

  if (totalItemCount === 0) {
    return <ProductGridError />;
  }

  if (enabledFeatures['seo-composable-product-grid']) {
    return (
      <ComposableProductGrid />
    );
  }

  return (
    <div className="product-grid" data-testid="product-grid">
      <ProductGrid
        brand={brand}
        cid={productGroups[0].cid}
        locale={locale}
        pageIndex={'0'}
        priceAdapter={catPriceAdapter}
        productCardComponent={showComposableProductCard ? CLPProductCard : null}
        productGridSource={'Bloomreach'}
        productGroups={productGroups}
        totalCount={totalItemCount}
        groupIndex={0}
        abSeg={undefined}
      />
    </div>
  );
};
export default CustomLandingPageProductGrid;
